/*
 * <copy-code> — copies a discount code to the clipboard.
 *
 * Reusable across sections. Click handling is delegated from the custom element
 * itself, so the button keeps working after theme editor re-renders and the
 * listener is torn down with the element. The copied state reverts on its own.
 */
const REVERT_DELAY = 1200;

class CopyCode extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this);
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    clearTimeout(this.revertTimer);
  }

  async handleClick(event) {
    const button = event.target.closest('[data-copy-code]');
    if (!button) return;

    const { copyCode } = button.dataset;
    if (!copyCode) return;

    try {
      await navigator.clipboard.writeText(copyCode);
      this.markCopied(copyCode);
    } catch (error) {
      console.error('copy-code: could not copy discount code', error);
    }
  }

  markCopied(code) {
    const status = this.querySelector('[data-copy-status]');
    clearTimeout(this.revertTimer);
    this.classList.add('is-copied');

    if (status) status.textContent = status.dataset.copyStatus.replace('[code]', code);

    this.revertTimer = setTimeout(() => {
      this.classList.remove('is-copied');
      if (status) status.textContent = '';
    }, REVERT_DELAY);
  }
}

if (!customElements.get('copy-code')) {
  customElements.define('copy-code', CopyCode);
}
